module.exports = __webpack_public_path__ + "static/media/ArrowDownNewKTM.489636a0.svg";